import { render, staticRenderFns } from "./ChatmessageForm.vue?vue&type=template&id=2b1659d4&"
import script from "./ChatmessageForm.vue?vue&type=script&lang=js&"
export * from "./ChatmessageForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatmessageForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports